import { generateConnectorConfigWebhookUrlDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const generateConnectorConfigWebhookUrlCallable = getCallable(
  generateConnectorConfigWebhookUrlDefinition,
);
